function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}


document.addEventListener("DOMContentLoaded", event => {

    //--------- Announcebar Js [All Pages] ---------
    const announceBar = document.querySelector(".announcebar");
    const announceBarContent = document.querySelector(".announcebar-carousel .slide-content");
    let isClosed = false;
    
    function updateAnnounceBarHeight() {
        if (!announceBar || !announceBarContent || isClosed) return;
        
        announceBar.style.height = announceBarContent.offsetHeight + "px";
    }
    
    document.body.addEventListener("click", function (e) {
        if (e.target.closest(".announcebar-close")) {
            isClosed = true;
            announceBar.style.height = "0px";
            
            setTimeout(() => {
                announceBar.style.display = "none";
                headerspace();
            }, 100);
        }
    });
    updateAnnounceBarHeight();


    //--------- Announcebar Swiper Js Start [Home Page] ---------
    // var announcebar_swiper = new Swiper(".announcebar-carousel", {
    //     slidesPerView: 1,
    //     speed: 1000,
    //     spaceBetween: 30,
    //     effect: "flip",
    //     loop: true,
    //     grabCursor: true,
    //     direction: "vertical",
    //     autoplay: {
    //         delay: 2500,
    //     },
    // });
    function announcebar_height() {
        const announcebar_content = document.querySelector(".announcebar .slide-content");
        const announcebar_contentHeight = announcebar_content ? announcebar_content.offsetHeight : 0;

        document.querySelectorAll(".announcebar-carousel").forEach(el => {
            el.style.height = announcebar_contentHeight + "px";
        });
    }
    announcebar_height();
    
    ["load", "resize", "orientationchange"].forEach(event => {
        window.addEventListener(event, updateAnnounceBarHeight);
        window.addEventListener(event, announcebar_height);
    });


    //--------- Header Space Js [All Pages] ---------
    function headerspace() {
        const header = document.querySelector(".site-header");
        const announcebar = document.querySelector(".announcebar");
        const announcebarHeight = announcebar ? announcebar.offsetHeight : 0;
        const headerHeight = header ? header.offsetHeight : 0;
        const totleHeight = announcebarHeight + headerHeight;

        // document.querySelectorAll(".site-header").forEach(el => {
        //     el.style.top = announcebarHeight + "px";
        // });

        // document.querySelectorAll(".main-wrapper").forEach(el => {
        //     el.style.paddingTop = totleHeight + "px";
        // });

        document.querySelectorAll(".hero-section").forEach(el => {
            el.style.height = `calc(100dvh - ${totleHeight}px)`;
        });
    }
    headerspace();
    ["resize", "load", "scroll", "orientationchange"].forEach(event => {
        window.addEventListener(event, headerspace);
    });


    //--------- Main Menu Js For Mobile ---------    
        //--------- Main Menu Js For Mobile ---------
    const MOBILE_MENU_BP = 851;

    function closeMobileMenu() {
        document.querySelector(".mob-menu-btn")?.classList.remove("active");
        document.querySelector(".head-center .main-menu")?.classList.remove("open");
        document.querySelectorAll(".main-menu .dropdown-menu.open").forEach(el => el.classList.remove("open"));
        document.querySelectorAll(".main-menu [aria-expanded='true']").forEach(el => el.setAttribute("aria-expanded", "false"));
        document.querySelectorAll(".main-menu .has-submenu.open").forEach(li => {
            li.classList.remove("open");
            const sub = li.querySelector(".submenu-list");
            if (sub) sub.style.maxHeight = null;
        });
        document.body.classList.remove("overflow-hidden");
    }

    document.body.addEventListener("click", function (e) {
        if (window.innerWidth >= MOBILE_MENU_BP) return;

        // OPEN MAIN MENU
        const openBtn = e.target.closest(".mob-menu-btn");
        if (openBtn) {
            e.preventDefault();
            openBtn.classList.add("active");
            document.querySelector(".head-center .main-menu")?.classList.add("open");
            document.body.classList.add("overflow-hidden");
            return;
        }

        // CLOSE MAIN MENU (X button or overlay)
        if (e.target.closest(".head-center .header-close") || e.target.matches(".site_overlay")) {
            e.preventDefault();
            closeMobileMenu();
            return;
        }

        // OPEN DROPDOWN PANEL (only when the top-level link itself is tapped)
        const topLink = e.target.closest(".main-menu .has-dropdown > .menu_item_link");
        if (topLink) {
            e.preventDefault();
            topLink.nextElementSibling?.classList.add("open");
            topLink.setAttribute("aria-expanded", "true");
            return;
        }

        // BACK FROM DROPDOWN PANEL
        const backBtn = e.target.closest(".dropdown-menu .back-btn");
        if (backBtn) {
            e.preventDefault();
            const dropdown = backBtn.closest(".dropdown-menu");
            dropdown.classList.remove("open");
            dropdown.previousElementSibling?.setAttribute("aria-expanded", "false");
            return;
        }

        // TOGGLE 3rd-LEVEL ACCORDION
        const subToggle = e.target.closest(".main-menu .has-submenu > a");
        if (subToggle) {
            e.preventDefault();
            const li = subToggle.parentElement;
            const sub = li.querySelector(".submenu-list");
            const isOpen = li.classList.toggle("open");
            sub.style.maxHeight = isOpen ? sub.scrollHeight + "px" : null;
            subToggle.setAttribute("aria-expanded", isOpen);
        }
    });

    // Reset mobile menu state when resizing up to desktop
    let wasMobileMenu = window.innerWidth < MOBILE_MENU_BP;
    window.addEventListener("resize", debounce(() => {
        const isMobile = window.innerWidth < MOBILE_MENU_BP;
        if (wasMobileMenu && !isMobile) closeMobileMenu();
        wasMobileMenu = isMobile;
    }, 150));

    //--------- Searchbar Js Start [Home Page] ---------   
    document.body.addEventListener("click", function (e) {
        const searchBar = document.querySelector(".searchbar");
        const sizeDrawer = document.querySelector(".size-drawer");
        
        if (e.target.closest(".search-btn")) {
            e.preventDefault();
            searchBar.classList.add("open");
            document.body.classList.add("overflow-hidden");
        }        
        if (e.target.closest(".searchbar-close")) {
            e.preventDefault();
            searchBar.classList.remove("open");
            document.body.classList.remove("overflow-hidden");
        }
        if (e.target.closest(".product-size-wrapper .size-label")) {
            e.preventDefault();
            sizeDrawer.classList.add("open");
            document.body.classList.add("overflow-hidden");
        }        
        if (e.target.closest(".size-drawer .close-btn")) {
            e.preventDefault();
            sizeDrawer.classList.remove("open");
            document.body.classList.remove("overflow-hidden");
        }
    });

    // Global event delegation
    document.addEventListener('click', (e) => {
        const target = e.target;
            if (target.hasAttribute('data-accordion-title')) {
            const isActive = target.classList.contains('active');
            document.querySelectorAll('[data-accordion-title]').forEach(item => {
            item.classList.remove('active');
            item.nextElementSibling.style.maxHeight = null;
            });
            if (!isActive) {
                target.classList.add('active');
                target.nextElementSibling.style.maxHeight = target.nextElementSibling.scrollHeight + 'px';
            }
        }

        // Overlay click
        if (target.matches('.site_overlay')) {
          document.querySelector('.menu-hamburger')?.classList.remove('active');
          document.body.classList.remove("overflow-hidden");
          document.querySelectorAll('.drawer-wpr, .search-outer, .header_wrapper > .menu-nav-wpr, .searchbar, .mega-menu-outer, #CartDrawer, .size-drawer')?.forEach(element => {
            element.classList.remove('open')
          });
        }

        // Drawer open/close
       if (target.hasAttribute('data-open-popup')) {
            e.preventDefault();
            const popup = document.querySelector(target.getAttribute('data-open-popup'));
            popup?.classList.add('open');
        }

        if (target.hasAttribute('data-close-popup')) {
            e.preventDefault();
            const popup = document.querySelector(target.getAttribute('data-close-popup'));
            popup?.classList.remove('open');
        }

        if (target.closest('.load-more-btn')) {
          const btn = target.closest('.load-more-btn');
          e.preventDefault();
          const url = btn.dataset.nextProduct;
          if (url) {
            btn.disabled = true;
            btn.querySelector('span').textContent = 'Loading...';
            loadMore(url);
          }
        }
    });


    var main_product_swiper = new Swiper(".main-product-carousel", {
        slidesPerView: 1,
        speed: 1000,
        spaceBetween: 30,
        effect: "fade",
        loop: true,
        grabCursor: true,
        // direction: "vertical",
        // autoplay: {
        //     delay: 2500,
        // },
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    });

    // Delivery Process Carousel
    let mySwiper = null;
    function delivery_process_Carousel() {
        const carousel = document.querySelector('.delivery-process');
        if (!carousel) return;

        const slideCount = carousel.querySelectorAll('.swiper-slide').length;
        const slidesToShow = 4;
        const windowWidth = window.innerWidth;

        const sliderSettings = {
            slidesPerView: 4,
            speed: 1000,
            spaceBetween: 30,
            loop: true,
            grabCursor: true,
            autoplay: {
                delay: 2500,
            },
            pagination: {
              el: '.swiper-pagination',
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                992: {
                    slidesPerView: 4,
                },
                641: {
                    slidesPerView: 3,
                },
                481: {
                    slidesPerView: 2,
                },
                320: {
                    slidesPerView: 1,
                },
            }
        };
        if (windowWidth < 768) {
            if (!mySwiper) {
                mySwiper = new Swiper(carousel, sliderSettings);
            }
        }
        else {
            if (slideCount > slidesToShow) {
                if (!mySwiper) {
                    mySwiper = new Swiper(carousel, sliderSettings);
                }
            } else {
                if (mySwiper) {
                    mySwiper.destroy(true, true);
                    mySwiper = null;
                }
            }
        }
    }
    delivery_process_Carousel();
    window.addEventListener('resize', delivery_process_Carousel);
});

 // load more 
function loadMore(url, containerSelector = '[data-load-more-wrapper]', buttonWrapperSelector = '.load-more-wpr') {
  fetch(url, { method: 'GET' })
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const newItems = doc.querySelectorAll(`${containerSelector} > *`);
      const container = document.querySelector(containerSelector);

      newItems.forEach((el) => container.appendChild(el));

      const newWrapper = doc.querySelector(buttonWrapperSelector);
      const oldWrapper = document.querySelector(buttonWrapperSelector);

      if (newWrapper && oldWrapper) {
        oldWrapper.replaceWith(newWrapper);
      } else if (!newWrapper && oldWrapper) {
        oldWrapper.remove();
      }
    })
    .catch((err) => {
      console.error('Load more error:', err);
    });
}

const stickyItem = document.querySelector(".sticky-add-to-cart");
const target = document.querySelector(".main-product-form");

if (stickyItem && target) {
  const observer = new IntersectionObserver(
    entries => {
      const entry = entries[0];
      if (!entry.isIntersecting) {
        stickyItem.classList.add("active");   // element OUT of viewport
      } else {
        stickyItem.classList.remove("active"); // element visible
      }
    },
    { threshold: 0 }
  );

  observer.observe(target);
}